"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6151],{

/***/ 3281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7379);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var hooks_common_useAccordingToScroll__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5571);
/* harmony import */ var lib_utils_format_number__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4593);
/* harmony import */ var lib_utils_deviceChecker__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7496);
/* harmony import */ var cds_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3887);




// hooks

// utils


// styles

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: ",
        ";\n  align-items: center;\n  position: fixed;\n  top: 56px;\n  left: 0;\n  width: 100%;\n  max-width: 100%;\n  height: 56px;\n  border-bottom: 1px solid ",
        ";\n  background-color: ",
        ";\n  scroll-behavior: smooth;\n  white-space: nowrap;\n  overflow-x: auto;\n  z-index: 2;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  ",
        " {\n    display: flex;\n    position: ",
        ";\n    top: 0px;\n    left: ",
        ";\n    max-width: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  height: 100%;\n  vertical-align: top;\n  cursor: pointer;\n  box-sizing: border-box;\n  white-space: nowrap;\n  cursor: pointer;\n\n  & > span {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    padding: 0 14px;\n    font-size: 14.336px;\n\n    ",
        " {\n      font-size: 16px;\n    }\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: 2px;\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: ",
        ";\n  height: 56px;\n\n  ",
        " {\n    display: block;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
/**
 * 리뷰 상단 네비게이션바
 * @param {object} props
 * @param {number} props.reviewCount 리뷰 총 개수
 */ var NavigationBar = function(param) {
    var reviewCount = param.reviewCount;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var classId = router.query.classId;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), isApp = ref[0], setIsApp = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)('PC'), view = ref1[0], setView = ref1[1];
    var ref2 = _slicedToArray((0,hooks_common_useAccordingToScroll__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        start: 84
    }), 2), stickyRef = ref2[0], isSticky = ref2[1];
    /**
   * 카테고리 클릭 함수
   * @param {'video' | 'curriculum' | 'introduce' | 'recommend' | 'refund'} type 카테고리 타입
   */ var onClickCategory = function(type) {
        var device = (0,lib_utils_deviceChecker__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
        if (!device.app()) {
            window.location.href = "".concat("https://www.classu.co.kr", "/class/classDetail/").concat(classId, "#").concat(type);
            return;
        }
        router.back();
    };
    var onScrollTop = function() {
        document.body.scrollIntoView({
            behavior: 'smooth'
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var device = (0,lib_utils_deviceChecker__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
        if (device.app()) {
            setIsApp(true);
        } else {
            setIsApp(false);
        }
    }, []);
    /** 화면 넓이 리사이징에 대한 레이아웃 변경 */ (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var onResize = function() {
            if (window.innerWidth > 1178) {
                setView('PC');
            } else {
                setView('Mobile');
            }
        };
        onResize();
        window.addEventListener('resize', onResize);
        return function() {
            return window.removeEventListener('resize', onResize);
        };
    }, []);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Layout, {
                ref: stickyRef,
                isSticky: isSticky,
                view: view,
                isApp: isApp,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tab, {
                        onClick: function() {
                            return onClickCategory('videoContainer');
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: "강의 영상"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tab, {
                        onClick: onScrollTop,
                        selected: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            children: [
                                "리뷰(",
                                (0,lib_utils_format_number__WEBPACK_IMPORTED_MODULE_6__/* .formatToPrice */ .t)(reviewCount ? reviewCount : 0),
                                ")"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tab, {
                        onClick: function() {
                            return onClickCategory('curriculum-wrapper');
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: "커리큘럼"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tab, {
                        onClick: function() {
                            return onClickCategory('prdInfoClass');
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: "클래스 소개"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tab, {
                        onClick: function() {
                            return onClickCategory('recommendation');
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: "추천"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tab, {
                        onClick: function() {
                            return onClickCategory('refundInfo');
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: "환불정책"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlankArea, {
                isApp: isApp
            })
        ]
    }));
};
var Layout = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-7ed809c4-0"
})(_templateObject(), function(param) {
    var isApp = param.isApp;
    return isApp === null ? 'none' : !isApp ? 'flex' : 'none';
}, cds_styles__WEBPACK_IMPORTED_MODULE_4__/* .palette.grey010 */ .DG.grey010, cds_styles__WEBPACK_IMPORTED_MODULE_4__/* .palette.white */ .DG.white, cds_styles__WEBPACK_IMPORTED_MODULE_4__/* .mediaQuery.large */ .cy.large, function(param) {
    var isSticky = param.isSticky;
    return isSticky ? 'fixed' : 'absolute';
}, function(param) {
    var isSticky = param.isSticky, view = param.view;
    if (isSticky) {
        if (view === 'PC') {
            return 'calc((100% - 1178px) / 2 + 12px)';
        } else {
            return '12px';
        }
    } else {
        return '0px';
    }
}, function(param) {
    var isSticky = param.isSticky, view = param.view, isDisplay = param.isDisplay;
    if (isSticky && !isDisplay) {
        if (view === 'PC') {
            return 'calc(1178px - 426px - 24px)';
        } else {
            return 'calc(100% - 426px - 24px)';
        }
    }
});
var Tab = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-7ed809c4-1"
})(_templateObject1(), cds_styles__WEBPACK_IMPORTED_MODULE_4__/* .mediaQuery.large */ .cy.large, function(param) {
    var selected = param.selected;
    return selected ? "".concat(cds_styles__WEBPACK_IMPORTED_MODULE_4__/* .palette.black */ .DG.black) : "rgba(0,0,0,0)";
});
var BlankArea = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7ed809c4-2"
})(_templateObject2(), function(param) {
    var isApp = param.isApp;
    return !isApp ? 'block' : 'none';
}, cds_styles__WEBPACK_IMPORTED_MODULE_4__/* .mediaQuery.large */ .cy.large);
/* harmony default export */ __webpack_exports__["Z"] = (NavigationBar);


/***/ }),

/***/ 8431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ class_SideInfo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./src/components/atoms/photos/Avatar.js
var Avatar = __webpack_require__(3315);
// EXTERNAL MODULE: ./src/components/atoms/rating/StarRating.js
var StarRating = __webpack_require__(2803);
// EXTERNAL MODULE: ./src/cds/styles.ts
var styles = __webpack_require__(3887);
;// CONCATENATED MODULE: ./src/components/molecules/class/sideInfo/ClassInfo.js



// components


// styles

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 16px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: fit-content;\n  min-height: 24px;\n  margin-bottom: 4px;\n\n  & > div {\n    width: 18px;\n    margin: 0;\n  }\n\n  & > span {\n    margin-left: 4px;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 24px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  min-height: 24px;\n  margin-bottom: 8px;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 24px;\n  color: ",
        ";\n  word-break: break-all;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  min-height: 16px;\n  margin-bottom: 10px;\n\n  & > span {\n    margin-top: -1px;\n    margin-left: 4px;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 16px;\n    color: #b4b4b4;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
/**
 * 사이드 클래스 정보
 * @param {object} props
 * @param {string} props.photo
 * @param {number} props.coachId
 * @param {string} props.coachName
 * @param {string} props.className
 * @param {{
 * 	score: number;
 *  count: number;
 * }} props.review
 */ var ClassInfo = function(param) {
    var classId = param.classId, photo = param.photo, coachId = param.coachId, coachName = param.coachName, className = param.className, review = param.review;
    var isExistReview = review.count > 0;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: "/user/".concat(coachId),
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CoachLayout, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            width: 18,
                            height: 18,
                            src: photo,
                            alt: coachName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: coachName
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassName, {
                children: className
            }),
            isExistReview && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StarLayout, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StarRating/* default */.Z, {
                        value: review.score,
                        xsmall: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: Math.ceil(review.score * 10) / 10
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "(",
                            review.count,
                            ")"
                        ]
                    })
                ]
            })
        ]
    }));
};
var Layout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c8ba1449-0"
})(_templateObject());
var CoachLayout = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-c8ba1449-1"
})(_templateObject1());
var ClassName = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-c8ba1449-2"
})(_templateObject2(), styles/* palette.black */.DG.black);
// TODO PHP와 임시적으로 색상 통일되어있음
var StarLayout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c8ba1449-3"
})(_templateObject3());
/* harmony default export */ var sideInfo_ClassInfo = (ClassInfo);

// EXTERNAL MODULE: ./src/lib/utils/format/number.js
var number = __webpack_require__(4593);
;// CONCATENATED MODULE: ./src/components/molecules/class/sideInfo/Price.js


// utils

// styles

function Price_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Price_templateObject() {
    var data = Price_taggedTemplateLiteral([
        "\n  margin-bottom: 24px;\n"
    ]);
    Price_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Price_templateObject1() {
    var data = Price_taggedTemplateLiteral([
        "\n  margin-right: 4px;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ff4b4f;\n"
    ]);
    Price_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Price_templateObject2() {
    var data = Price_taggedTemplateLiteral([
        "\n  margin-left: 6px;\n  font-weight: 500;\n  font-size: 14px;\n  text-decoration: line-through;\n  color: #b4b4b4;\n"
    ]);
    Price_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Price_templateObject3() {
    var data = Price_taggedTemplateLiteral([
        "\n  display: block;\n  margin-top: 8px;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 24px;\n  color: ",
        ";\n\n  & > strong {\n    color: ",
        ";\n    font-weight: 500;\n\n    &:first-child {\n      font-size: 16px;\n    }\n\n    &:last-child {\n      font-size: 20px;\n    }\n  }\n"
    ]);
    Price_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
/**
 * 사이드 클래스 가격
 * @param {object} props
 * @param {string} props.salePercent
 * @param {number} props.originPrice
 * @param {string} props.totalPrice
 */ var ClassPrice = function(param) {
    var salePercent = param.salePercent, originPrice = param.originPrice, totalPrice = param.totalPrice;
    var discountRate = salePercent ? salePercent.split('.')[0] : salePercent;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Price_Layout, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalePer, {
                        children: [
                            discountRate,
                            "% 할인"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OriginPrice, {
                        children: [
                            (0,number/* formatToPrice */.t)(originPrice),
                            "원"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalePrice, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "월 "
                    }),
                    totalPrice,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "원"
                    })
                ]
            })
        ]
    }));
};
var Price_Layout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3bf52919-0"
})(Price_templateObject());
// TODO PHP와 임시적으로 색상 통일되어있음
var SalePer = styled_components_browser_esm/* default.strong.withConfig */.ZP.strong.withConfig({
    componentId: "sc-3bf52919-1"
})(Price_templateObject1());
var OriginPrice = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-3bf52919-2"
})(Price_templateObject2());
var SalePrice = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-3bf52919-3"
})(Price_templateObject3(), styles/* palette.black */.DG.black, styles/* palette.black */.DG.black);
/* harmony default export */ var Price = (ClassPrice);

// EXTERNAL MODULE: ./src/hooks/common/useModal.js + 4 modules
var useModal = __webpack_require__(5042);
// EXTERNAL MODULE: ./src/hooks/domain/review/useRedirectUrl.js
var useRedirectUrl = __webpack_require__(3225);
;// CONCATENATED MODULE: ./src/components/molecules/class/sideInfo/Actions.js


// hooks


// stylesd

function Actions_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Actions_templateObject() {
    var data = Actions_taggedTemplateLiteral([
        "\n  margin-bottom: 12px;\n"
    ]);
    Actions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Actions_templateObject1() {
    var data = Actions_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 48px;\n  border-radius: 4px;\n  background-color: ",
        ";\n  font-size: inherit;\n  color: ",
        ";\n  transition: 0.1s ease;\n\n  & > span {\n    margin-left: 6px;\n    font-size: 14px;\n    line-height: 24px;\n    color: #f7fe54;\n  }\n\n  & ~ & {\n    margin-top: 12px;\n  }\n"
    ]);
    Actions_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
/**
 * 사이드 클래스 수강연장 / 강의이동
 * @param {object} props
 * @param {number} props.classId 클래스 ID
 * @param {number} props.remainCnt 남은 자리 개수
 * @param {boolean} props.isPayment 구매 여부
 * @param {boolean} props.isLogined 로그인 여부
 */ var Actions = function(param) {
    var classId = param.classId, remainCnt = param.remainCnt, isPayment = param.isPayment, isLogined = param.isLogined;
    var initModal = (0,useModal/* default */.Z)().initModal;
    var setRedirectUrl = (0,useRedirectUrl/* default */.Z)().setRedirectUrl;
    /**
   * 남은 자리 수
   * - DB단에서 최대: 30
   * - View단에서 최대: 19
   */ var groupRemainCnt = remainCnt > 19 ? remainCnt - 11 : remainCnt;
    var onApply = function() {
        if (isLogined) {
            window.location.href = "".concat("https://www.classu.co.kr", "/class/pay/payinfo/").concat(classId);
        } else {
            setRedirectUrl({
                type: 'payment'
            });
            initModal({
                name: 'Login'
            });
        }
    };
    var onExtend = function() {
        window.location.href = "".concat("https://www.classu.co.kr", "/class/pay/payinfo/").concat(classId);
    };
    var onMove = function() {
        window.location.href = "".concat("https://www.classu.co.kr", "/class/lecture/").concat(classId);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Actions_Layout, {
        className: "noselect",
        children: [
            isPayment && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                        isActive: true,
                        onClick: onExtend,
                        children: "수강연장"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                        onClick: onMove,
                        children: "강의이동"
                    })
                ]
            }),
            !isPayment && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button, {
                isActive: true,
                onClick: onApply,
                children: [
                    "수강신청",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "남은자리: ",
                            groupRemainCnt
                        ]
                    })
                ]
            })
        ]
    }));
};
var Actions_Layout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e6f8e34-0"
})(Actions_templateObject());
// TODO PHP와 임시적으로 색상 통일되어있음
var Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-4e6f8e34-1"
})(Actions_templateObject1(), function(param) {
    var isActive = param.isActive;
    return isActive ? '#ff0e15' : styles/* palette.grey060 */.DG.grey060;
}, styles/* palette.white */.DG.white);
/* harmony default export */ var sideInfo_Actions = (Actions);

// EXTERNAL MODULE: ./src/lib/utils/format/time.js
var time = __webpack_require__(508);
;// CONCATENATED MODULE: ./src/components/molecules/class/sideInfo/Detail.js



// utils

// styles

function Detail_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Detail_templateObject() {
    var data = Detail_taggedTemplateLiteral([
        "\n  padding: 10px 20px;\n  background-color: ",
        ";\n  border-radius: 4px;\n"
    ]);
    Detail_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Detail_templateObject1() {
    var data = Detail_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  padding: 10px 0;\n\n  & ~ & {\n    border-top: 1px solid ",
        ";\n  }\n"
    ]);
    Detail_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Detail_templateObject2() {
    var data = Detail_taggedTemplateLiteral([
        "\n  font-family: 'Roboto';\n  margin-right: 20px;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 20px;\n"
    ]);
    Detail_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Detail_templateObject3() {
    var data = Detail_taggedTemplateLiteral([
        "\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n"
    ]);
    Detail_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
/**
 * 사이드 클래스 수강연장 / 강의이동
 * @param {object} props
 * @param {boolean} props.openFlag 개강 여부
 * @param {string} props.openDate 개강 날짜
 * @param {import('types/slices/class').Package[]} props.packageList 수강권 종류
 * @param {boolean} props.isMission 미션 존재 여부
 */ var Detail = function(param) {
    var openFlag = param.openFlag, openDate = param.openDate, packageList = param.packageList, isMission = param.isMission;
    var ref6 = (0,react.useState)(''), startDate = ref6[0], setStartDate = ref6[1];
    var ref1 = (0,react.useState)(''), packageMessage = ref1[0], setPackageMessage = ref1[1];
    (0,react.useEffect)(function() {
        var packList = [];
        packageList.forEach(function(pack) {
            if (pack.type === 'S') {
                var ref, ref2, ref3, ref4, ref5;
                if (~((ref = pack.name) === null || ref === void 0 ? void 0 : ref.indexOf('1개월'))) {
                    packList.push('1개월');
                } else if (~((ref2 = pack.name) === null || ref2 === void 0 ? void 0 : ref2.indexOf('3개월'))) {
                    packList.push('3개월');
                } else if (~((ref3 = pack.name) === null || ref3 === void 0 ? void 0 : ref3.indexOf('12개월'))) {
                    packList.push('12개월');
                } else if (~((ref4 = pack.name) === null || ref4 === void 0 ? void 0 : ref4.indexOf('무제한'))) {
                    packList.push('평생');
                } else if (~((ref5 = pack.name) === null || ref5 === void 0 ? void 0 : ref5.indexOf('평생'))) {
                    packList.push('평생');
                }
            }
        });
        if (packList.length > 0) {
            setPackageMessage("".concat(packList.join(' \xb7 '), " 수강권"));
        } else {
            setPackageMessage('1개월 수강권');
        }
    }, [
        packageList
    ]);
    (0,react.useEffect)(function() {
        if (!openDate) {
            return;
        }
        var date = new Date(openDate);
        if (date < (0,time/* getKoreaDate */.jw)()) {
            setStartDate('즉시 시작');
        } else {
            var transformedDate = openDate.replace(/-/g, '.');
            setStartDate(transformedDate);
        }
    }, [
        openFlag,
        openDate
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Detail_Layout, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: "개강날짜"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                            children: startDate
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: "수강기간"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                            children: [
                                packageMessage,
                                " 중 선택"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: "장학혜택"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                                children: "활동 우수 장학금 100% 환급"
                            }),
                            isMission && /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                                children: "미션 수행 장학금 10% 환급"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: "주의사항"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                            children: [
                                "인원 마감 시",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "가격이 상승될 수 있습니다."
                            ]
                        })
                    })
                ]
            })
        ]
    }));
};
var Detail_Layout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9dbdaf9b-0"
})(Detail_templateObject(), styles/* palette.background.bg2 */.DG.background.bg2);
var Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9dbdaf9b-1"
})(Detail_templateObject1(), styles/* palette.border.b1 */.DG.border.b1);
var Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-9dbdaf9b-2"
})(Detail_templateObject2());
var Content = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-9dbdaf9b-3"
})(Detail_templateObject3());
/* harmony default export */ var sideInfo_Detail = (Detail);

// EXTERNAL MODULE: ./src/lib/styles/animations.js
var animations = __webpack_require__(1751);
;// CONCATENATED MODULE: ./src/components/atoms/skeletons/ClassSideInfo.js


// styles


function ClassSideInfo_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ClassSideInfo_templateObject() {
    var data = ClassSideInfo_taggedTemplateLiteral([
        "\n  margin-bottom: 16px;\n  width: 80%;\n  height: 48px;\n  border-radius: 8px;\n  background-color: ",
        ";\n  animation: 2s ",
        " ease infinite;\n"
    ]);
    ClassSideInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ClassSideInfo_templateObject1() {
    var data = ClassSideInfo_taggedTemplateLiteral([
        "\n  margin-bottom: 24px;\n  width: 32%;\n  height: 38px;\n  border-radius: 8px;\n  background-color: ",
        ";\n  animation: 2s ",
        " ease infinite;\n"
    ]);
    ClassSideInfo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ClassSideInfo_templateObject2() {
    var data = ClassSideInfo_taggedTemplateLiteral([
        "\n  margin-bottom: 24px;\n  width: 42%;\n  height: 59px;\n  border-radius: 8px;\n  background-color: ",
        ";\n  animation: 2s ",
        " ease infinite;\n"
    ]);
    ClassSideInfo_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ClassSideInfo_templateObject3() {
    var data = ClassSideInfo_taggedTemplateLiteral([
        "\n  height: 311px;\n  border-radius: 8px;\n  background-color: ",
        ";\n  animation: 2s ",
        " ease infinite;\n"
    ]);
    ClassSideInfo_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
/**
 * 클래스 사이드바 스켈레톤
 * @param {object}} props
 */ var ClassSideInfoSkeleton = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoLoading, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StarLoading, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceLoading, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyLoading, {})
        ]
    }));
};
var InfoLoading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b2eff023-0"
})(ClassSideInfo_templateObject(), styles/* palette.grey030 */.DG.grey030, animations/* blink */.lt);
var StarLoading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b2eff023-1"
})(ClassSideInfo_templateObject1(), styles/* palette.grey030 */.DG.grey030, animations/* blink */.lt);
var PriceLoading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b2eff023-2"
})(ClassSideInfo_templateObject2(), styles/* palette.grey030 */.DG.grey030, animations/* blink */.lt);
var BodyLoading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b2eff023-3"
})(ClassSideInfo_templateObject3(), styles/* palette.grey030 */.DG.grey030, animations/* blink */.lt);
/* harmony default export */ var ClassSideInfo = (ClassSideInfoSkeleton);

// EXTERNAL MODULE: ./src/hooks/common/useStore.ts
var useStore = __webpack_require__(8004);
;// CONCATENATED MODULE: ./src/components/organisms/class/SideInfo.js



// components





// hooks

// utils

// styles

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function SideInfo_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function SideInfo_templateObject() {
    var data = SideInfo_taggedTemplateLiteral([
        "\n  display: none;\n  position: sticky;\n  top: 20px;\n  right: 0px;\n  width: 390px;\n  margin: 20px 0 20px 24px;\n  padding: 32px 20px 20px;\n  border-radius: 8px;\n  background-color: ",
        ";\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);\n\n  ",
        " {\n    display: block;\n  }\n"
    ]);
    SideInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SideInfo_templateObject1() {
    var data = SideInfo_taggedTemplateLiteral([
        "\n  display: inline-block;\n  padding: 2px 6px;\n  margin-bottom: 14px;\n  border: 1px solid #ff0e15;\n  border-radius: 2px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #ff0e15;\n"
    ]);
    SideInfo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
/**
 * 사이드 클래스 정보
 */ var SideInfo = function() {
    var ref = _slicedToArray((0,useStore/* useSelector */.v)(function(state) {
        return [
            state.class.info,
            state.class.selected
        ];
    }), 2), classInfo = ref[0], selectedClass = ref[1];
    var reviewStatis = (0,useStore/* useSelector */.v)(function(state) {
        return state.review.statis;
    });
    var myId = (0,useStore/* useSelector */.v)(function(state) {
        return state.user.info.id;
    });
    var ref1 = (0,react.useState)('PC'), view = ref1[0], setView = ref1[1];
    var isExistReview = reviewStatis.review_count > 0;
    /** 화면 넓이 리사이징에 대한 레이아웃 변경 */ (0,react.useEffect)(function() {
        var onResize = function() {
            if (window.innerWidth > 1178) {
                setView('PC');
            } else {
                setView('Mobile');
            }
        };
        onResize();
        window.addEventListener('resize', onResize);
        return function() {
            return window.removeEventListener('resize', onResize);
        };
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SideInfo_Layout, {
            view: view,
            children: [
                classInfo.isLoaded && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        !isExistReview && /*#__PURE__*/ (0,jsx_runtime.jsx)(EarlybirdSaleBadge, {
                            children: "최초 오픈 할인 이벤트 진행중"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(sideInfo_ClassInfo, {
                            classId: selectedClass.class_id,
                            coachId: selectedClass.coach_id,
                            photo: selectedClass.coach_photo,
                            coachName: selectedClass.coach_name,
                            className: selectedClass.name,
                            review: {
                                score: reviewStatis.review_score,
                                count: (0,number/* formatToPrice */.t)(reviewStatis.review_count)
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                            salePercent: selectedClass.package_sale_per,
                            originPrice: selectedClass.payment_info_data2,
                            totalPrice: selectedClass.package_total_payment
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(sideInfo_Actions, {
                            classId: selectedClass.id,
                            remainCnt: selectedClass.groupRemain_cnt,
                            isPayment: classInfo.payment_yn === 'Y',
                            isLogined: !!myId
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(sideInfo_Detail, {
                            openFlag: selectedClass.open_flag,
                            openDate: selectedClass.open_date,
                            packageList: selectedClass.package,
                            isMission: selectedClass.class_mission_cnt > 0
                        })
                    ]
                }),
                !classInfo.isLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassSideInfo, {})
            ]
        })
    }));
};
var SideInfo_Layout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-58c3a39-0"
})(SideInfo_templateObject(), styles/* palette.white */.DG.white, styles/* mediaQuery.large */.cy.large);
// TODO PHP와 임시적으로 색상 통일되어있음
var EarlybirdSaleBadge = styled_components_browser_esm/* default.i.withConfig */.ZP.i.withConfig({
    componentId: "sc-58c3a39-1"
})(SideInfo_templateObject1());
/* harmony default export */ var class_SideInfo = (SideInfo);


/***/ }),

/***/ 8716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Participation; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./src/components/organisms/common/NotificationCenter.js + 1 modules
var NotificationCenter = __webpack_require__(2747);
// EXTERNAL MODULE: ./src/cds/styles.ts
var styles = __webpack_require__(3887);
;// CONCATENATED MODULE: ./src/components/molecules/headers/Logo.js



// styles

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex-shrink: 0;\n  display: none;\n\n  ",
        " {\n    display: block;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n  flex-basis: 130px;\n  width: 130px;\n  height: auto;\n  max-width: none;\n\n  ",
        " {\n    display: block;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  width: 30px;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
/** 헤더 로고 */ var Logo = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        href: "".concat("https://www.classu.co.kr"),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomeLink, {
            className: "noselect",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                    src: "".concat("https://cdn.classu.co.kr", "/img/class/classu_logo_white.png"),
                    alt: "logo"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileImage, {
                    src: "".concat("https://cdn.classu.co.kr", "/img/class/classtok_symbol_w.png"),
                    alt: "logo"
                })
            ]
        })
    }));
};
var HomeLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-c88679cd-0"
})(_templateObject(), styles/* mediaQuery.large */.cy.large);
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-c88679cd-1"
})(_templateObject1(), styles/* mediaQuery.large */.cy.large);
var MobileImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-c88679cd-2"
})(_templateObject2(), styles/* mediaQuery.large */.cy.large);
/* harmony default export */ var headers_Logo = (Logo);

// EXTERNAL MODULE: ./src/components/molecules/headers/SearchInput.js
var SearchInput = __webpack_require__(3349);
// EXTERNAL MODULE: ./src/components/atoms/photos/Avatar.js
var Avatar = __webpack_require__(3315);
// EXTERNAL MODULE: ./src/components/atoms/icons/Notify.js
var Notify = __webpack_require__(7068);
// EXTERNAL MODULE: ./src/cds/buttons/Icon.tsx
var Icon = __webpack_require__(7732);
// EXTERNAL MODULE: ./src/cds/icons/index.tsx
var icons = __webpack_require__(6643);
// EXTERNAL MODULE: ./src/hooks/common/useStore.ts
var useStore = __webpack_require__(8004);
// EXTERNAL MODULE: ./src/hooks/bridge/useCommonBridge.js
var useCommonBridge = __webpack_require__(5397);
// EXTERNAL MODULE: ./src/hooks/bridge/useBridgeCallback.js
var useBridgeCallback = __webpack_require__(8372);
// EXTERNAL MODULE: ./src/lib/utils/deviceChecker.js
var deviceChecker = __webpack_require__(7496);
// EXTERNAL MODULE: ./src/lib/utils/helper.js
var helper = __webpack_require__(4058);
;// CONCATENATED MODULE: ./src/components/organisms/headers/Participation.js





// components







// hooks



// utils


// styles

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function Participation_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function Participation_templateObject() {
    var data = Participation_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 56px;\n  border-bottom: ",
        ";\n  z-index: ",
        ";\n  background-color: #131313;\n  transform: translateZ(0);\n\n  ",
        " {\n    height: 84px;\n  }\n"
    ]);
    Participation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Participation_templateObject1() {
    var data = Participation_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  white-space: nowrap;\n  flex-wrap: nowrap;\n  width: 1400px;\n  max-width: 100%;\n  height: 100%;\n  padding: 0 16px;\n  margin: auto;\n"
    ]);
    Participation_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Participation_templateObject2() {
    var data = Participation_taggedTemplateLiteral([
        "\n  width: 76px;\n  height: 56px;\n\n  ",
        " {\n    height: 84px;\n  }\n"
    ]);
    Participation_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = Participation_taggedTemplateLiteral([
        "\n  flex-grow: 1;\n  width: 50px;\n\n  &:first-child {\n    display: flex;\n    justify-content: flex-start;\n  }\n\n  &:last-child {\n    display: flex;\n    justify-content: flex-end;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = Participation_taggedTemplateLiteral([
        "\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = Participation_taggedTemplateLiteral([
        "\n  flex-grow: 1;\n  display: none;\n  position: relative;\n\n  ",
        " {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = Participation_taggedTemplateLiteral([
        "\n  margin-right: 12px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = Participation_taggedTemplateLiteral([
        "\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  padding: 4px 12px;\n  margin-right: 14px;\n  border-radius: 4px;\n  background: #2b2b2b;\n  font-weight: 500;\n  font-size: 14px;\n  color: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = Participation_taggedTemplateLiteral([
        "\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  margin-left: 14px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = Participation_taggedTemplateLiteral([
        "\n  height: 32px;\n  padding: 0 4px;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  font-size: 12px;\n  line-height: 30px;\n  color: ",
        ";\n  cursor: pointer;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
/** 클래스 헤더 */ var ClassHeader = function(_param) {
    var onOpenNotify = function onOpenNotify() {
        var notifyEvent = new CustomEvent('onOpenNotify', {
            detail: {
                winWidth: window.outerWidth
            }
        });
        document.dispatchEvent(notifyEvent);
    };
    var props = _extends({}, _param);
    var router = (0,next_router.useRouter)();
    var ref = _slicedToArray((0,useStore/* useSelector */.v)(function(state) {
        return [
            state.user.info,
            state.user.newsCount.news_unread_count, 
        ];
    }), 2), userInfo = ref[0], existNotification = ref[1];
    var ref1 = (0,react.useState)(false), isEnableNotify = ref1[0], setIsEnableNotify = ref1[1];
    var ref2 = (0,react.useState)(false), isVisibleNotify = ref2[0], setIsVisibleNotify = ref2[1];
    var header = (0,react.useRef)(null);
    var ref3 = (0,useCommonBridge/* default */.Z)(), onCloseWebView = ref3.onCloseWebView, goToProfile = ref3.goToProfile;
    var isExistUser = userInfo.isLoaded && userInfo.id;
    (0,useBridgeCallback/* default */.Z)({
        onOpenNotify: onOpenNotify
    });
    var onBackButton = function() {
        if (!onCloseWebView()) {
            router.back();
        }
    };
    var onLogin = function() {
        var loginRedirectUrl = (0,helper/* isExistWindow */.br)() ? window.location.pathname : '';
        router.push("/user?url=".concat(loginRedirectUrl));
    };
    var onToggleNotify = function() {
        return setIsVisibleNotify(function(v) {
            return !v;
        });
    };
    var doOpenNotify = function(param) {
        var detail = param.detail;
        var winWidth = detail.winWidth;
        if (winWidth < styles/* mediaQuery.large */.cy.large) {
            return;
        }
        setIsVisibleNotify(true);
    };
    var onProfile = function() {
        return goToProfile(userInfo.id);
    };
    /** 알림 아이콘 표시 여부 */ (0,react.useEffect)(function() {
        var device = (0,deviceChecker/* default */.Z)();
        if (device.app()) {
            setIsEnableNotify(false);
        } else {
            setIsEnableNotify(true);
        }
    }, []);
    (0,react.useEffect)(function() {
        if (!isEnableNotify) {
            return;
        }
        document.addEventListener('onOpenNotify', doOpenNotify);
        return function() {
            document.removeEventListener('onOpenNotify', doOpenNotify);
        };
    }, [
        isEnableNotify
    ]);
    var LeftSide = /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftSideLayout, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton, {
                width: 24,
                height: 54,
                mode: "Dark",
                onClick: onBackButton,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    name: "ic_back_m",
                    width: 24,
                    height: 24
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(headers_Logo, {})
        ]
    });
    var RightSide = /*#__PURE__*/ (0,jsx_runtime.jsxs)(RightSideLayout, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: "".concat("https://www.classu.co.kr", "/class/open"),
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassOpenButton, {
                    children: "클래스개설"
                })
            }),
            isExistUser && isEnableNotify && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                    width: 30,
                    height: 30,
                    mode: "Dark",
                    onClick: onToggleNotify,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notify/* default */.Z, {
                        width: 30,
                        height: 30,
                        isActive: !!existNotification
                    })
                })
            }),
            isExistUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarButton, {
                onClick: onProfile,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    width: 32,
                    height: 32,
                    src: userInfo.photo,
                    alt: userInfo.name
                })
            }),
            !isExistUser && userInfo.isLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginButton, {
                onClick: onLogin,
                children: "로그인"
            }),
            !userInfo.isLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginSkeleton, {})
        ]
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, _objectSpread({
                ref: header
            }, props, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentLayout, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                            children: LeftSide
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput/* default */.Z, {
                            mode: "Dark"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                            children: RightSide
                        })
                    ]
                })
            })),
            isExistUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationCenter/* default */.Z, {
                isVisible: isVisibleNotify,
                onClose: onToggleNotify
            })
        ]
    }));
};
// TODO PHP와 임시적으로 색상 통일되어있음
var Layout = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-794cf589-0"
})(Participation_templateObject(), function(props) {
    return props.noBorderBottom ? 'none' : "1px solid ".concat(styles/* palette.border.b1 */.DG.border.b1);
}, styles/* zIndex.header */.W5.header, styles/* mediaQuery.large */.cy.large);
var ContentLayout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-794cf589-1"
})(Participation_templateObject1());
var LoginSkeleton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-794cf589-2"
})(Participation_templateObject2(), styles/* mediaQuery.large */.cy.large);
var Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-794cf589-3"
})(_templateObject3());
var LeftSideLayout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-794cf589-4"
})(_templateObject4());
var RightSideLayout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-794cf589-5"
})(_templateObject5(), styles/* mediaQuery.large */.cy.large);
var BackButton = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.Z).withConfig({
    componentId: "sc-794cf589-6"
})(_templateObject6());
// TODO PHP와 임시적으로 색상 통일되어있음
var ClassOpenButton = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-794cf589-7"
})(_templateObject7(), styles/* palette.white */.DG.white);
var AvatarButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-794cf589-8"
})(_templateObject8());
var LoginButton = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-794cf589-9"
})(_templateObject9(), styles/* palette.border.b1 */.DG.border.b1, styles/* palette.grey010 */.DG.grey010);
/* harmony default export */ var Participation = (ClassHeader);


/***/ }),

/***/ 2052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ class_thunk_getClass; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 2 modules
var redux_toolkit_esm = __webpack_require__(5700);
// EXTERNAL MODULE: ./src/slices/class.js
var slices_class = __webpack_require__(3482);
// EXTERNAL MODULE: ./src/api/index.js + 1 modules
var api = __webpack_require__(66);
;// CONCATENATED MODULE: ./src/api/class.js

/* =============================== GET ================================ */ /**
 * 클래스 정보 호출 API
 * @version 3
 * @param {object} props
 * @param {number} props.classId 클래스 ID
 */ var getClass = function(param) {
    var classId = param.classId;
    return api/* default.get */.Z.get("/enfit1/api/v3/class/".concat(classId), {
        headers: {
            Authorization: "Bearer ".concat("eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOi8vd3d3LmNsYXNzdS5jby5rci9tb2Rvby9zdG9yZUxvZ2luQVBJIiwiaWF0IjoxNzEyMTIyODAzLCJleHAiOjE3MTMzMzI0MDMsIm5iZiI6MTcxMjEyMjgwMywianRpIjoiM0IwbElaMnRBckNhbWRrQiIsInN1YiI6MTg0NzkwMSwicHJ2IjoiOTYyYTE0ZDQ4YzQyOWUzYTZhYWIzNjEwYzAzNTJiZmJiNDVlZmM1OCJ9.Th2dkBQJrfPwnoYRvoqRY0d-o9iD8T-tIBHwHGIF6fA")
        }
    });
}; /* =============================== POST =============================== */  /* =============================== PUT ================================ */  /* ============================== DELETE ============================== */ 

;// CONCATENATED MODULE: ./src/slices/class.thunk.js


// actions

// api

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
/**
 * @dispatch 클래스 데이터 호출
 * @param {object} props
 * @param {string} props.classId
 */ var class_thunk_getClass = (0,redux_toolkit_esm/* createAsyncThunk */.hg)('class/getClass', function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(param, param1) {
        var classId, dispatch, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    classId = param.classId, dispatch = param1.dispatch;
                    _ctx.next = 3;
                    return getClass({
                        classId: classId
                    });
                case 3:
                    res = _ctx.sent;
                    /** 클래스 정보 */ dispatch(slices_class/* updateClassInfo */.Tv({
                        class_have_status: res.class_have_status,
                        payment_yn: res.payment_yn
                    }));
                    /* 선택된 클래스 정보 */ dispatch(slices_class/* updateSelectedClass */.Mn(res.class));
                    return _ctx.abrupt("return", Promise.resolve(true));
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());


/***/ })

}]);